module.exports = __webpack_public_path__ + "img/017-half-moon-2.552e094d.svg";